import React from "react";
import "./Footer.css";

import Logo from "../assets/images/teckpik-whiteandorangelogo.png";
import FacebookIcon from "../assets/images/fb-icon.png";
import InstagramIcon from "../assets/images/insta-icon.png";
import TiktokIcon from "../assets/images/tiktok-icon.png";

const Footer = () => {
  return (
    <footer className="custom-footer py-5">
      <div className="container">
        <div className="row g-5">
          {/* Company Info */}
          <div className="col-lg-4 col-md-6">
            <div className="company-info">
              <div className="logo-section mb-3">
                <img src={Logo} alt="TECKPIK" className="footer-logo" />
              </div>
              <p className="company-description">
                We create stunning digital experiences that help your business
                grow.
              </p>
              <div className="social-media-icons">
                <a
                  href="https://facebook.com/teckpik"
                  className="social-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={FacebookIcon}
                    alt="Facebook"
                    className="social-icon"
                  />
                </a>
                <a
                  href="https://instagram.com/teckpik"
                  className="social-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={InstagramIcon}
                    alt="Instagram"
                    className="social-icon"
                  />
                </a>
                <a
                  href="https://www.tiktok.com/@teckpik1"
                  className="social-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={TiktokIcon} alt="TikTok" className="social-icon" />
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-lg-4 col-md-6">
            <div className="quick-links">
              <h4 className="footer-heading mb-3">Quick Links</h4>
              <ul className="footer-links-list">
                <li>
                  <a href="/" className="footer-link">
                    Home
                  </a>
                </li>
                <li>
                  <a href="/services" className="footer-link">
                    Services
                  </a>
                </li>
                <li>
                  <a href="/projects" className="footer-link">
                    Portfolio
                  </a>
                </li>
                <li>
                  <a href="/about" className="footer-link">
                    About
                  </a>
                </li>
                <li>
                  <a href="/contact" className="footer-link">
                    Contact
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Contact Info */}
          <div className="col-lg-4 col-md-6">
            <div className="footer-contact-info">
              <h4 className="footer-heading mb-3">Contact</h4>
              <div className="footer-contact-details">
                <div className="footer-contact-item">
                  <span className="footer-contact-icon">📞</span>
                  <a href="tel:+923170725045" className="footer-contact-link">
                    +92-317-0725045
                  </a>
                </div>
                <div className="footer-contact-item">
                  <span className="footer-contact-icon">✉️</span>
                  <a
                    href="mailto:ceo@teckpik.com"
                    className="footer-contact-link"
                  >
                    ceo@teckpik.com
                  </a>
                </div>
                <div className="footer-contact-item">
                  <span className="footer-contact-icon">📍</span>
                  <span className="footer-contact-text">
                    Teckpik, 3rd Floor Pacific Center,
                    <br />
                    F-8 Markaz, Islamabad
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="footer-bottom mt-5 pt-4 border-top border-secondary">
          <div className="row align-items-center">
            <div className="col-md-6">
              <p className="copyright-text mb-0">
                © 2026 Teckpik. All rights reserved.
              </p>
            </div>
            <div className="col-md-6 text-md-end">
              <div className="footer-bottom-links">
                <a href="/privacy" className="footer-link">
                  Privacy Policy
                </a>
                <a href="/terms" className="footer-link">
                  Terms of Service
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
